/** The workspace that an accepted invite joined. */
export interface AcceptedWorkspace {
  id: string;
  name: string;
  role: string;
}

/**
 * Accepts a Lookout invite through the CSRF-guarded Hono route (not oRPC). The server runs every check of the invite
 * page: the proven email, the RudderStack access of a sibling workspace, and the invite's role. Throws the server's
 * refusal text.
 */
export async function acceptInvite(inviteId: string): Promise<AcceptedWorkspace> {
  const res = await fetch('/api/workspace/accept-invite', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    credentials: 'include',
    body: JSON.stringify({ inviteId }),
  });
  const body = (await res.json().catch(() => ({}))) as { error?: string; workspace?: AcceptedWorkspace };
  if (!res.ok || !body.workspace) {
    throw new Error(body.error ?? 'Failed to accept invite');
  }
  return body.workspace;
}
